<template>
  <a-modal :title="form.indexid ? '修改信息' : '新增信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false" width="800px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="数据类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio value="1">
            酒店
          </a-radio>
          <a-radio value="2">
            别墅
          </a-radio>
          <a-radio value="3">
            游艇
          </a-radio>
          <a-radio value="4">
            豪车
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="图片素材">
        <!-- {{ form.images }} -->
        <!-- <draggable v-model="form.images" :sort="true" :disabled="readonly" @end="onEnd" key="123">
          <div v-for="(v, i) in form.images" style="position: relative;">
            <div @paste="handlePaste($event, i)" @dragstart="handleDragStart"
              :contenteditable="contenteditable && !readonly" @keydown="handleKeydown">
             
            </div>
          </div>

        </draggable> -->
        <draggable v-model="form.images" :sort="true" key="456" class="imagebox">
          <div class="imgcontainer" v-for="(imgvalue, imgindex) in form.images"
            :style="{ width: 120 + 'px', height: 120 + 'px' }">
            <img crossorigin alt="img" :src="imgvalue">
            <div class="delimg" @click.stop="delimg(imgindex)">
              <a-icon type="close" />
            </div>
          </div>
          <a-upload-dragger class="imgcontainer" name="file" loading style="height: 100%;"
            :style="{ width: 120 + 'px', height: 120 + 'px' }" :multiple="false" :showUploadList="false"
            :customRequest="onDrop">
            <p class="ant-upload-drag-icon" style="margin: 0;">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-hint">点击或拖拽至此上传</p>
          </a-upload-dragger>
        </draggable>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title">
        <a-textarea v-model="form.title" placeholder="标题内容" :auto-size="{ minRows: 1, maxRows: 3 }" />
      </a-form-model-item>
      <a-form-model-item label="副标题" prop="subtitle">
        <a-textarea v-model="form.subtitle" placeholder="副标题内容" :auto-size="{ minRows: 3, maxRows: 10 }" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" placeholder="排序" />
      </a-form-model-item>
    </a-form-model>
    <input type="file" id="imageInput" @change="changefile" hidden accept="image/*" />
  </a-modal>
</template>

<script>
import draggable from "vuedraggable";
import "element-ui/lib/theme-chalk/index.css";
export default {
  components: { draggable },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        images: [],
        title: "",
        subtitle: "",
        type: "",
        sort: 0
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        type: [
          {
            required: true,
            message: "请输入选择数据类型",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: false,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
  },
  methods: {
    delimg(index) {
      this.form.images.splice(index, 1)
    },
    onEnd2(value) {
      console.log(value)
    },
    // 处理文件拖放
    onDrop(event) {
      if (!event) return
      const isJpgOrPng = event.file.type === 'image/jpeg' || event.file.type === 'image/png' || event.file.type === 'image/jpg';
      if (!isJpgOrPng) {
        return this.$message.error('只能上传图片文件!');
      }
      const droppedFiles = event.file;
      // this.handleFiles(droppedFiles);
      this.changefile(droppedFiles)
    },

    changefile(file) {
      // const file = files[0];
      if (file) {
        // console.log("图片名称:", file);
        // const reader = new FileReader();
        // reader.onload = (e) => {
        //     // this.imageSrc = e.target.result;
        //     this.DataList[this.imageIndex].value.push(e.target.result)
        // };
        // reader.readAsDataURL(file);
        const formData = new FormData();
        formData.append('file', file);
        this.spinning = true
        this.$http({
          url: '/admin/sys/upload',
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data', // 告诉服务器上传的是文件
          },
          data: formData
        }).then(res => {
          this.form.images.push(res.data.url)
        })
      } else {
        console.log("未选择图片");
      }
      document.getElementById('imageInput').value = '';
    },
    init(id) {
      this.visible = true;
      this.form.indexid = id;
      if (id) {
        this.$http({
          url: "/admin/appindex/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
            images: res.data.images ? res.data.images.split(",") : [],
          }
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
            images: this.form.images.join(","),
          };
          this.$http({
            url: this.form.indexid ? "/admin/appindex/update" : "/admin/appindex/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.indexid ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.custom-tree-node {
  display: flex;
  width: 100%;
  /* border: 1px solid red; */
}
</style>
<style scoped lang="scss">
.imagebox {
  display: flex;
  // justify-content: center;
  flex-wrap: wrap;

  .imgcontainer {
    width: 100px;
    height: 100px;
    background: #FFF;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .delimg {
      position: absolute;
      width: 25%;
      height: 25%;
      background: red;
      color: #FFF;
      right: 5%;
      top: 5%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 100%;
      font-weight: bold;
    }
  }
}
</style>